if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"react_dock_0_1_0","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(7(14|22|26|32)|122|228|53|869)$/.test(chunkId)},
		rootOutputDir: "../../",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}